import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=fe3bdb7c&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=fe3bdb7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe3bdb7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe3bdb7c')) {
      api.createRecord('fe3bdb7c', component.options)
    } else {
      api.reload('fe3bdb7c', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=fe3bdb7c&scoped=true&", function () {
      api.rerender('fe3bdb7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sh7aTIf0ruUx/JS/comp/GuestBox.vue"
export default component.exports